(function() {
    // 1. 定义你想要异步加载的CSS文件的URL中的关键词
    // 这样做的好处是，即使文件名后面跟了版本号等动态参数，也能匹配到
    const asyncCssKeywords = [
        'accelerated-checkout-backwards-compat.css',
        'storefront.css', // Trustify App
        'rappi-front.css'             // Rapi App
    ];

    // 2. 查找 <head> 中所有的 <link rel="stylesheet"> 标签
    const allStylesheetLinks = document.head.querySelectorAll('link[rel="stylesheet"]');
    // 3. 遍历所有找到的样式表链接
    allStylesheetLinks.forEach(link => {
        const href = link.href;
        // 检查链接的href是否包含我们定义的任何一个关键词
        const needsAsync = asyncCssKeywords.some(keyword => href.includes(keyword));

        // 4. 如果匹配成功，并且它不是已经被异步加载的（防止重复操作）
        if (needsAsync && link.media !== 'print') {
            console.log('正在将CSS转为异步加载:', href);

            // 核心操作：将其转换为异步加载模式
            link.media = 'print';
            link.onload = function() {
                setTimeout(() => {
                    this.media = 'all';
                    this.onload = null; // 清除事件处理器，避免内存泄漏
                }, 1000);
            };
            
            // 5. 添加一个 <noscript> 回退，确保在JS禁用的情况下样式也能加载
            const noscriptTag = document.createElement('noscript');
            const fallbackLink = document.createElement('link');
            fallbackLink.rel = 'stylesheet';
            fallbackLink.href = href;
            noscriptTag.appendChild(fallbackLink);
            link.parentNode.insertBefore(noscriptTag, link.nextSibling);
        }
    });

})();